import { MfeComponent } from '@/common/MicroFrontEnds';
import useLoadSoftPullMfe from '@/common/Modals/SoftPullMfeModal/useLoadSoftPullMfe';
import { SOFTPULL_MODULE } from '~/constants/common/MfeModules';
import { useIsLoggedIn } from '~/context/common/UserContext';
import useMfeMountGate from '~/hooks/common/mfe/useMfeMountGate';
import useSoftPullModalSync from './useSoftPullModalSync';
import useEventListeners from '../common/Modals/SoftPullMfeModal/useEventListeners';

const dummyFn = () => {};

type OwnProps = {
  consumer: 'Drive' | 'FLP' | 'Home' | 'Search' | 'VDP';
  isAddCoApplicantModalOpen: boolean;
  isEditCoApplicantModalOpen?: boolean;
  isSoftPullModalOpen: boolean;
  landingHeading?: string;
  landingSubheading?: string;
  showLogo?: boolean;
  setIsAddCoApplicantModalOpen: (isOpen: boolean) => void;
  setIsEditCoApplicantModalOpen?: (isOpen: boolean) => void;
  setIsSoftPullModalOpen: (isOpen: boolean) => void;
  setShouldRefreshSoftPull: () => void;
};

export default function SoftPullMfeModal({
  consumer,
  isAddCoApplicantModalOpen,
  isEditCoApplicantModalOpen = false,
  isSoftPullModalOpen,
  landingHeading,
  landingSubheading,
  showLogo,
  setIsAddCoApplicantModalOpen,
  setIsEditCoApplicantModalOpen = dummyFn,
  setIsSoftPullModalOpen,
  setShouldRefreshSoftPull
}: OwnProps) {
  const isLoggedIn = useIsLoggedIn();
  const canMount = useMfeMountGate(SOFTPULL_MODULE);

  useLoadSoftPullMfe();
  let intendedModal: 'add-co-applicant' | 'edit-co-applicant' | 'softpull' =
    'softpull';

  if (isAddCoApplicantModalOpen) {
    intendedModal = 'add-co-applicant';
  } else if (isEditCoApplicantModalOpen) {
    intendedModal = 'edit-co-applicant';
  }

  useSoftPullModalSync({
    canMount,
    consumer,
    intendedModal,
    isAddCoApplicantModalOpen,
    isEditCoApplicantModalOpen,
    isSoftPullModalOpen,
    landingHeading,
    landingSubheading,
    showLogo,
    setAddCoApplicantModalOpen: setIsAddCoApplicantModalOpen,
    setEditCoApplicantModalOpen: setIsEditCoApplicantModalOpen,
    setSoftPullModalOpen: setIsSoftPullModalOpen
  });

  useEventListeners(setShouldRefreshSoftPull);

  return (
    <>
      {/* Wait for the previous instance's teardown before rendering — see useMfeMountGate. */}
      {canMount ? (
        <MfeComponent<{
          externalIsLoggedIn: boolean;
          softPullSource: string;
        }>
          component="default"
          module="SoftPullModule"
          softPullSource={consumer}
          externalIsLoggedIn={isLoggedIn}
        />
      ) : null}
    </>
  );
}
